<template>

<main>
    <nav class="navbar navbar-expand-md navbar-light navbar-laravel">
        <div class="container-fluid">
            <a @click="$router.go(-1)" class="navbar-brand icon-left">
                 Map Admin Console
            </a>

            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>

            <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <!-- Left Side Of Navbar -->
                <ul class="navbar-nav mr-auto">

                </ul>

                <!-- Right Side Of Navbar -->
                <ul class="navbar-nav ml-auto">
                    <!-- Authentication Links -->
                    <li class="nav-item">
                        <a class="nav-link icon-ok-circle mx-2" style="position:relative;" href="/donotcall">
                            Approvals
                            <div v-if="dnc_count" class="badge badge-danger">{{dnc_count}}</div>
                        </a>
                    </li>

                    <li class="nav-item">
                        <a class="nav-link icon-qrcode" href="/showkey">
                            Show Map Link QR Code
                        </a>
                    </li>

                    <li class="nav-item">
                        <a class="nav-link px-2 mx-2" @click="expandGeometryTools = ! expandGeometryTools" href="#">
                            Geometry Tools <span v-if="expandGeometryTools" class="icon-up"></span><span v-else class="icon-down"></span>
                        </a>
                    </li>

                    <li v-if="$screenfull.enabled" class="nav-item">
                        <a @click="collapseNav(); $screenfull.toggle();" class="mx-2 nav-link icon-resize-full" href="#"> Full Screen</a>
                    </li>

                    <li class="nav-item dropdown">
                        <a id="navbarDropdown" class="nav-link dropdown-toggle mx-2 icon-user" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            {{ user_name }} <span class="caret"></span>
                        </a>

                        <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
                            <a class="dropdown-item" href="/logout"
                                onclick="event.preventDefault();
                                                document.getElementById('logout-form').submit();">
                                Logout
                            </a>

                            <form id="logout-form" action="/logout" method="POST" style="display: none;">
                                <input type="hidden" name="_token" id="csrf-token" :value="csrf_token" />
                            </form>
                            <a class="dropdown-item" href="/password">
                                Change Password
                            </a>
                            <a class="dropdown-item" href="/register">Create New Administrator</a>
                        </div>
                    </li>

                </ul>
            </div>
        </div>
    </nav>

    <div class="container-fluid">
        <div v-if="errorMessage" class="row" style = "padding-left:350px; padding-top:55px;">
            <div class="col-md-12 mt-5 pt-5">
                <h1 class="text-center text-danger icon-cancel-circle">
                    Application Error
                </h1>
                <h1 class="text-center text-danger">
                    {{errorMessage}}
                </h1>
            </div>
        </div>
        <div v-else-if="loadThreads > 0" class="row"
            style = "
            position:absolute;
            display:block;
            background-color:white;
            left:400px;
            top:100px;
            z-index:100;
            border-radius:20px;
            padding:20px;
            border:5px solid gray;
            ">
            <h1 class="text-center"><span class="icon-spin4 animate-spin"></span>
                Loading Map Data
            </h1>
            <h1 class="text-center">
                {{loadThreads}} to go. Please Wait...
            </h1>
        </div>
        <div v-if="$store.getters.allFeatures.length == 0 && (!listFlipped)" class="row" style = "padding-left:350px; padding-top:55px;">
            <div class="col-md-12 mt-5 p-5">
                <h1 class="text-center">
                    Please select some maps from the left hand side, then click "Edit Maps" to begin editing...
                </h1>
            </div>
        </div>
        <olMap v-else
            left="350px" top="55px"
            :interactionType="interactionType"
            :interactionSnap="interactionSnap"
            :showNewNote="uiMode == 'create-note'"
            v-on:singleFeatureSelected="onMapSelect"
            v-on:multiFeatureSelected="onMapDeselect"
            v-on:noFeatureSelected="onMapDeselect"
            @drawend="onMapDrawEnd"
            @modifyend="onMapModifyEnd"
            @translateend="onMapModifyEnd"
        ></olMap>

        <div class="flip-card" :class="{flipped:listFlipped}" style="position:fixed;top:55px;left:0px;bottom:0;width:350px;">
            <div class="flip-card-inner">

                <div class="flip-card-front">

                    <button type="button" class="btn btn-outline-danger" style="width:168px;margin:2px 0 2px 2px" @click="clearMapSelection">Clear Selection</button>
                    <button type="button" class="btn btn-outline-success" style="width:168px;margin:2px 2px 2px 0;" @click="editMaps">Edit Maps</button>

                    <div style="overflow-y:scroll;width:100%;position:absolute;top:42px;bottom:0;">
                        <button  v-for="map in mapInfo" v-bind:key="map.id" @click="checkMap(map.id)" :class="{'active':checkedMaps.includes(map.id)}" class="btn btn-light contrast-select" style="width:97%; margin:5px;">
                            {{map.text}}
                        </button>
                    </div>

                </div>

                <div class="flip-card-back" style="width:100%;height:100%;">

                    <div>
                        <button type="button" class="btn btn-light" style="width:100%;border-radius:0;margin-bottom:3px;" @click="onSelectMapsClicked" :disabled="uiMode == 'structure-modified'"><span v-if="uiMode != 'structure-modified'" class="icon-left">Select Maps</span><span v-else class="icon-attention">Map Modified</span></button>
                    </div>

                    <treeView
                        style="position:absolute;width:100%;top:38px;bottom:0;overflow-y:scroll;"
                        @selection_changed="onTreeSelectionChanged"
                        @node_moved="onTreeNodeMoved"
                        :disableUpdates="disableTreeUpdate"
                    ></treeView>

                </div>

            </div>
        </div>

        <transition name="slide">
        <div v-if="expandGeometryTools" class="card" style="position:fixed;top:55px;right:0px;">
            <div class="card-body py-2">
                <table>
                    <tr>
                        <td><button @click="interactionType='Select'" :class="{'active':interactionType=='Select'}" class="btn btn-light contrast-select geometry-tool icon-cursor"> Select</button></td>
                        <td><button @click="interactionType='Modify'" :class="{'active':interactionType=='Modify'}" class="btn btn-light contrast-select geometry-tool icon-wrench"> Modify</button></td>
                        <td><button @click="interactionType='Move'" :class="{'active':interactionType=='Move'}" class="btn btn-light contrast-select geometry-tool icon-move"> Move</button></td>
                        <td><button @click="interactionType='Polygon'" :class="{'active':interactionType=='Polygon'}" class="btn btn-light contrast-select geometry-tool icon-pencil-neg" :disabled="$store.getters.viewProperties == $store.getters.viewBlocks"> Create</button></td>
                    </tr>
                    <tr>
                        <td><button @click="onPropertyVisibilityClick" type="button" class="btn btn-light contrast-select geometry-tool icon-map-pin" :class="{'active':$store.getters.viewProperties}">Properties</button></td>
                        <td><button @click="onBlockVisibilityClick" type="button" class="btn btn-light contrast-select geometry-tool icon-map" :class="{'active':$store.getters.viewBlocks}">Blocks</button></td>
                        <td><button @click="interactionSnap= !interactionSnap" :class="{'active':interactionSnap}" class="btn btn-light contrast-select geometry-tool mx-0 my-0 icon-resize-small"> Snap</button></td>
                        <td><delete-confirm class="geometry-tool" placement="bottom" :action="`/freshdata/${$store.getters.selectedId}`" :disabled="!$store.getters.selectedId" @success="onDeleteSuccess"> Delete</delete-confirm></td>
                    </tr>
                </table>
            </div>
        </div>
        </transition>

        <transition name="slide">
        <div v-if="uiMode=='edit-map'" id="map-details" class="card" style="position:fixed;top:55px;left:350px;">
            <div class="card-header" @click="expandFeatureDetails = ! expandFeatureDetails">
                Map Details <span v-if="expandFeatureDetails" class="icon-up"></span><span v-else class="icon-down"></span>
            </div>
            <transition name="slide">
            <div v-show="expandFeatureDetails" class="card-body">
                <ajax-form
                    v-slot="{model}"
                    :action="`/freshdata/${$store.getters.selectedId}`"
                    method="PUT"
                    :hidden-input="{}"
                    @cancel="expandFeatureDetails = false"
                    @success="updateFeatureDetails"
                    @success-complete="setUiMode('none')"
                    :modelSrc="$store.getters.singleSelection"
                    >
                    <m-textinput label="Map Name: " name="name"
                        :model="model"
                    ></m-textinput>
                </ajax-form>
            </div>
            </transition>
        </div>
        </transition>


        <transition name="slide">
        <div v-if="uiMode=='edit-block'" id="block-details" class="card" style="position:fixed;top:55px;left:350px;">
            <div class="card-header" @click="expandFeatureDetails = ! expandFeatureDetails">
                Block Details <span v-if="expandFeatureDetails" class="icon-up"></span><span v-else class="icon-down"></span>
            </div>
            <transition name="slide">
            <div v-show="expandFeatureDetails" class="card-body">
                <ajax-form
                    v-slot="{model}"
                    :action="`/freshdata/${$store.getters.selectedId}`"
                    method="PUT"
                    :hidden-input="{}"
                    @cancel="expandFeatureDetails = false"
                    @success="updateFeatureDetails"
                    @success-complete="setUiMode('none')"
                    :modelSrc="$store.getters.singleSelection"
                    >
                    <m-textinput label="Block Name: " name="name"
                        :model="model"
                    ></m-textinput>
                </ajax-form>
            </div>
            </transition>
        </div>
        </transition>

        <transition name="slide">
        <div v-if="uiMode=='edit-property'" id="property-details" class="card" style="position:fixed;top:55px;left:350px;">
            <div class="card-header" @click="expandFeatureDetails = ! expandFeatureDetails">
                Property Details <span v-if="expandFeatureDetails" class="icon-up"></span><span v-else class="icon-down"></span>
            </div>
            <transition name="slide">
            <div v-show="expandFeatureDetails" class="card-body">

                <ajax-form
                    v-slot="{model}"
                    :action="`/freshdata/${$store.getters.selectedId}`"
                    method="PUT"
                    :hidden-input="{}"
                    @cancel="expandFeatureDetails = false"
                    @success="updateFeatureDetails"
                    @success-complete="setUiMode('none')"
                    :modelSrc="$store.getters.singleSelection"
                    >


                    <m-textinput label="Unit Number: " name="unit"
                        :model="model"
                    ></m-textinput>
                    <m-textinput label="House Number: " name="number"
                        :model="model"
                    ></m-textinput>
                    <m-textinput label="Street: " name="street"
                        :model="model"
                    ></m-textinput>

                    <m-checkinput label="Do Not Call"
                        :model="model"
                        name="do_not_call"
                    ></m-checkinput>

                    <m-textarea label="DNC Details: " name="dnc_details"
                        :model="model"
                        :disabled="!model.vals.do_not_call"
                    ></m-textarea>

                </ajax-form>

            </div>
            </transition>
        </div>
        </transition>

        <transition name="slide">
        <div v-if="uiMode=='structure-modified'" id="structure-modified" class="card" style="position:fixed;top:55px;left:350px;width:300px;">
            <div class="card-header">
                Map Modified
            </div>
            <div class="card-body">

                <ajax-form
                    v-slot="{model}"
                    :action="`/freshdata/structure`"
                    method="PUT"
                    :hidden-input="{}"
                    submit_text = "Save"
                    @cancel="onCancelModifyStructure"
                    @success="onSuccessModifyStructure"
                    @success-complete="onSuccessCompleteModifyStructure"
                    :modelSrc="$store.getters.modifiedStructure"
                    >
                    <p>You have modified the map structure.  When you are finished, click 'Save' to save your changes, or 'Cancel' discard your changes and reload the map.</p>

                </ajax-form>

            </div>
        </div>
        </transition>

    </div>

    <!-- BOOTSTRAP MODALS.  THESE ARE INVISIBLE ON PAGE LOAD -->
    <!-- Create Property -->
    <modal title="New Property Details" :shown="(!!createFeatureGeometry) && $store.getters.viewProperties" @dismiss="onCancelCreateFeature">
        <ajax-form
            v-slot="{model}"
            :action="`/freshdata/property`"
            method="POST"
            :hidden-input="{geometry:createFeatureGeometry}"
            @cancel="onCancelCreateFeature"
            @success="onCreateFeatureSuccess"
            @success-complete="onCancelCreateFeature"
            >

            <m-select label="Parent Block:" name="block_id"
                required
                :model="model" :options="blockSelectOptions"
            ></m-select>


            <m-textinput label="Unit Number: " name="unit"
                :model="model"
            ></m-textinput>
            <m-textinput label="House Number: " name="number"
                :model="model"
            ></m-textinput>
            <m-textinput label="Street: " name="street"
                :model="model"
            ></m-textinput>

            <m-checkinput label="Do Not Call"
                :model="model"
                name="do_not_call"
            ></m-checkinput>

            <m-textarea label="DNC Details: " name="dnc_details"
                :model="model"
                :disabled="!model.vals.do_not_call"
            ></m-textarea>

        </ajax-form>
    </modal>

    <!-- Create Block -->
    <modal title="New Block Details" :shown="(!!createFeatureGeometry) && $store.getters.viewBlocks" @dismiss="onCancelCreateFeature">
        <ajax-form
            v-slot="{model}"
            :action="`/freshdata/block`"
            method="POST"
            :hidden-input="{geometry:createFeatureGeometry}"
            @cancel="onCancelCreateFeature"
            @success="onCreateFeatureSuccess"
            @success-complete="onCancelCreateFeature"
            >

            <m-select label="Parent Map:" name="map_id"
                required
                :model="model" :options="mapSelectOptions"
            ></m-select>


            <m-textinput label="Block Name: " name="name"
                :model="model"
            ></m-textinput>

        </ajax-form>
    </modal>

</main>

</template>


<script>

export default {
    data(){
        return {
            is_admin,
            csrf_token,
            user_name,
            dnc_count, // count of approvals from the server.
            uiMode : "none",
            errorMessage:null,
            pageTitle:"Loading Map, Please Wait...",
            listFlipped:false,
            checkedMaps:[],
            loadThreads:0,
            expandFeatureDetails:false,
            expandGeometryTools:false,
            interactionType:"Select",
            interactionSnap:false,
            structureModified:false,
            createFeatureGeometry:null,
            mapInfo:[],
            disableTreeUpdate:true,
        }
    },
    mounted: function(){
        //populateMapView(this.$route, this.$router);
        //AttachAjaxSubmit();
        //map = null;
        if (! this.is_admin){
            this.$router.replace('/map');
        }
    },

    beforeRouteEnter (to, from, next) {
        // called when the route that renders this component has changed,
        // but this component is reused in the new route.
        // For example, for a route with dynamic params `/foo/:id`, when we
        // navigate between `/foo/1` and `/foo/2`, the same `Foo` component instance
        // will be reused, and this hook will be called when that happens.
        // has access to `this` component instance.

        // the beforeRouteEnter function is called prior to the vue being created,
        // so we need to do our work in the next() callback which has access
        // to the component.
        next(comp=>{
            //populateMapView(to, comp.$router);
            //AttachAjaxSubmit();

            comp.errorMessage = null;
            comp.loadMapIndex();

        });
    },

    methods:{
        loadMapIndex(){
            // just load the list of maps
            axios.get('/freshdata')
            .then((response) => {
                this.mapInfo = response.data.mapData;
                this.dnc_count = response.data.details.dnc_count;
            })
            .catch((error) => {
                    this.errorMessage = error.message;
                    console.log(error.response);
            });
        },
        collapseNav: function(){
            $("#navbarSupportedContent").collapse('hide');
        },
        onMapSelect: function(selected){
            this.$store.commit('deselectInvisible');
            if (this.$store.getters.singleSelection.type == "property"){
                this.setUiMode('edit-property');
            } else if (this.$store.getters.singleSelection.type == "block") {
                this.setUiMode('edit-block');
            } else if (this.$store.getters.singleSelection.type == "map") {
                this.setUiMode('edit-map');
            }
        },
        onMapDeselect: function(deselected){
            this.setUiMode('none');
            this.$store.commit('deselectInvisible');
        },
        onMapModifyEnd: function(features){
            this.structureModified = true;
            this.setUiMode('structure-modified');
        },
        onCancelModifyStructure(){
            this.editMaps();
            this.structureModified = false;
            this.uiMode = 'none';
        },
        onSuccessModifyStructure(response){
            Object.values(this.$store.getters.allFeatures).forEach((val)=>{
                if (val.structureModified){
                    this.$store.commit('attribute', {id:val.id, attribute:'structureModified', value:false});
                    this.$store.commit('attribute', {id:val.id, attribute:'propDetailsChanged', value:true});
                }
            });
        },
        onSuccessCompleteModifyStructure(response){
            this.structureModified = false;
            this.uiMode = 'none';
        },
        onMapDrawEnd: function(feature){
            this.createFeatureGeometry = feature.getGeometry().transform('EPSG:3857','EPSG:4326').getCoordinates()[0];
        },
        onCancelCreateFeature: function(){
            this.createFeatureGeometry = null;
        },
        onCreateFeatureSuccess:function(response){
            this.$store.commit('feature', response.data);
            if (response.data.type == 'block'){
                this.loadMapIndex();
            }
        },
        onDeleteSuccess(){
            this.$store.commit('deleteFeature', this.$store.getters.selectedId);
        },
        onTreeSelectionChanged: function(selection){
            if (this.$store.getters.selectedId){
                this.setUiMode('edit-' + this.$store.getters.singleSelection.type);
            } else {
                this.setUiMode('none');
            }

        },
        onTreeNodeMoved(data){
           this.structureModified = true;
           this.setUiMode('structure-modified');
        },
        setUiMode: function(mode){
            this.collapseNav();
            if (this.structureModified){
                this.uiMode = 'structure-modified';
                return;
            }

            // close existing menus and give time to animate collapse if they are open.
            if (this.uiMode != 'none'){
                this.uiMode = 'none';
                setTimeout(()=>{this.setUiMode(mode)}, 250);
            } else {
                this.uiMode = mode;
            }
        },
        updateFeatureDetails: function(vals){
            // this function is called on completion of Feature detail altering
            // http transactions.  We need to update the property store.
            if (vals.data.type != 'map'){
                vals.data.propDetailsChanged = true;
            }
            this.$store.commit('feature', vals.data);
        },
        editMaps: function(){
            this.$store.commit('clearMaps');
            this.errorMessage = null; // clear any old error messages.
            this.checkedMaps.forEach((val)=>{

                // work out the block id's for each selected map
                // and start multiple promises for the block data
                var mapInfoNode = this.mapInfo.find((mi)=>{ return mi.id == val });

                this.$store.commit('feature', mapInfoNode);

                mapInfoNode.blocks.forEach((block)=>{

                    this.loadThreads += 1;

                    // grab each block
                    axios.get(`/freshdata/${block.id}`)
                    .then((response) => {
                        this.$store.commit('features', response.data.mapData);
                        this.$store.commit('features', response.data.noteData);
                        // zoom the view when all the new data is added.
                        this.loadThreads-=1;
                        if (this.loadThreads == 0){
                            this.$store.commit('incView');
                            this.disableTreeUpdate = false;
                        }
                    })
                    .catch((error) => {
                        this.loadThreads-=1;
                        this.errorMessage = error.message;
                    });
                });

                // also get the map overiew data
                this.loadThreads += 1
                axios.get(`/freshdata/${val}`)
                .then((response) => {
                    this.$store.commit('features', response.data.mapData);
                    this.$store.commit('features', response.data.noteData);
                    this.loadThreads-=1;
                    // zoom the view when all the new data is added.
                    if (this.loadThreads == 0){
                        this.$store.commit('incView');
                        this.disableTreeUpdate = false;
                    }
                })
                .catch((error) => {
                    this.loadThreads-=1;
                    this.errorMessage = error.message;
                });

            });

            this.listFlipped = true;
        },
        onBlockVisibilityClick:function(){
            this.$store.commit('viewBlocks', ! this.$store.getters.viewBlocks);
            if (this.$store.getters.viewBlocks == this.$store.getters.viewProperties && this.interactionType == 'Polygon') this.interactionType = "Select";
        },
        onPropertyVisibilityClick:function(){
            this.$store.commit('viewProperties', ! this.$store.getters.viewProperties);
            if (this.$store.getters.viewBlocks == this.$store.getters.viewProperties && this.interactionType == 'Polygon') this.interactionType = "Select";
        },
        clearMapSelection: function(){
            this.checkedMaps = [];
        },
        checkMap:function(mapid){
            if(this.checkedMaps.includes(mapid)){
                this.checkedMaps = this.checkedMaps.filter(function(e) { return e != mapid });
            } else {
                this.checkedMaps.push(mapid);
            }
        },
        onSelectMapsClicked(e){
            this.listFlipped = false;
            this.$store.commit('clearMaps');
            this.setUiMode('none');
            this.errorMessage = null; // clear any old error messages.
        },
    },
    computed:{
        blockSelectOptions(){
            var retVal = [];
            Object.values(this.$store.getters.block).forEach((item)=>{
                var parent = Object.values(this.$store.getters.map).find((val)=>{return val.id == item.parent;});
                retVal.push([item.id.slice("block-".length), `${parent.text} / ${item.name}`]);
            });
            return retVal;
        },
        mapSelectOptions(){
            var retVal = [];
            Object.values(this.$store.getters.map).forEach((item)=>{
                retVal.push([item.id.slice("map-".length), `${item.text}`]);
            });
            return retVal;
        },
    }

}

</script>

